import { render, staticRenderFns } from "./OrcamentoItemAlerta.vue?vue&type=template&id=206be516&scoped=true"
import script from "./OrcamentoItemAlerta.vue?vue&type=script&lang=js"
export * from "./OrcamentoItemAlerta.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItemAlerta.vue?vue&type=style&index=0&id=206be516&prod&scoped=true&lang=css"
import style1 from "./OrcamentoItemAlerta.vue?vue&type=style&index=1&id=206be516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206be516",
  null
  
)

export default component.exports